// extracted by mini-css-extract-plugin
module.exports = {"socialsSection":"socials_socialsSection__ppSw1","wrapper":"socials_wrapper__b020m","icon":"socials_icon__wJk_b","streamElementsLogo":"socials_streamElementsLogo__aAcg1"};